<template>
  <div class="tw-flex tw-flex-col tw-items-start tw-justify-center">
    <PopoverBillPublicApi :global-id="column.id" :bill-number="String(column.number)" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import PopoverBillPublicApi from '@/components/PopoverBillPublicApi.vue'
import { FragmentType, graphql, useFragment } from '@/gql'

const PaymentRequestPrIdColumn = graphql(`
  fragment PaymentRequestPrIdColumn on PaymentRequest {
    id
    number
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestPrIdColumn>
}>()

const column = computed(() => useFragment(PaymentRequestPrIdColumn, props.row))
</script>

<style scoped></style>
